module.exports = __webpack_public_path__ + "static/media/terachats_branco.ae6b1b48.png";